import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/stepper/style";
import _Stepper from "vant/es/stepper";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/uploader/style";
import _Uploader from "vant/es/uploader";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/form/style";
import _Form from "vant/es/form";
import "vant/es/switch-cell/style";
import _SwitchCell from "vant/es/switch-cell";
import "vant/es/switch/style";
import _Switch from "vant/es/switch";
import "vant/es/collapse-item/style";
import _CollapseItem from "vant/es/collapse-item";
import "vant/es/collapse/style";
import _Collapse from "vant/es/collapse";
import "vant/es/radio-group/style";
import _RadioGroup from "vant/es/radio-group";
import "vant/es/radio/style";
import _Radio from "vant/es/radio";
import "vant/es/checkbox-group/style";
import _CheckboxGroup from "vant/es/checkbox-group";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/popover/style";
import _Popover from "vant/es/popover";
import "vant/es/tabbar/style";
import _Tabbar from "vant/es/tabbar";
import "vant/es/tabbar-item/style";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
// 按需全局引入 vant组件
import Vue from 'vue';
Vue.use(_Icon);
Vue.use(_Toast);
Vue.use(_Button);
Vue.use(_Cell);
Vue.use(_List);
Vue.use(_Popup);
Vue.use(_Tabbar).use(_TabbarItem);
Vue.use(_Popover);
Vue.use(_Checkbox);
Vue.use(_CheckboxGroup);
Vue.use(_Radio);
Vue.use(_RadioGroup);
Vue.use(_Collapse);
Vue.use(_CollapseItem);
Vue.use(_Switch);
Vue.use(_SwitchCell);
Vue.use(_Form);
Vue.use(_Field);
Vue.use(_Uploader);
Vue.use(_Loading);
Vue.use(_Stepper);
Vue.use(_Swipe);
Vue.use(_SwipeItem);